import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { Nav, Footer } from "./Nav";
import { Card } from "./Card";
import { useShop } from "./useShop";
import { CATEGORY_META, MOODS, GROUPS, BROWSE_GOALS, BROWSE_TRADITIONS } from "../data/mock";
import { Seo } from "./Seo";

export function Catalog() {
  const { catalog, wishedIds, toggleWish, buy, partner, openItem } = useShop();
  const location = useLocation();
  const routeKey = location.pathname.replace("/", "");
  const params = new URLSearchParams(location.search);
  const mood = params.get("mood");
  const goal = params.get("goal");
  const tradition = params.get("tradition");

  const group = GROUPS[routeKey];
  const meta = CATEGORY_META[routeKey];
  const isExplore = location.pathname.startsWith("/explore");

  const text = (c) => `${c.title} ${c.desc || ""} ${c.trust_label || ""} ${(c.badges || []).join(" ")}`.toLowerCase();

  const { items, title, eyebrow, blurb } = useMemo(() => {
    if (group) {
      const list = group.ids.map((id) => catalog.find((c) => c.id === id)).filter(Boolean);
      return { items: list, title: group.title, eyebrow: group.eyebrow, blurb: group.blurb };
    }
    if (meta) {
      return { items: catalog.filter((c) => c.category === meta.cat), title: meta.title, eyebrow: meta.eyebrow, blurb: meta.blurb };
    }
    if (isExplore && mood) {
      const m = MOODS.find((x) => x.id === mood);
      return { items: catalog.filter((c) => (c.moods || []).includes(mood)), title: m ? m.label : "Explore", eyebrow: "RECOMMENDED FOR YOU", blurb: "Matched to how you feel \u2014 change your preferences anytime." };
    }
    if (isExplore && goal) {
      const g = BROWSE_GOALS.find((x) => x.id === goal);
      const keys = g ? g.keys : [goal];
      return { items: catalog.filter((c) => keys.some((k) => text(c).includes(k))), title: g ? g.label : "By Goal", eyebrow: "BROWSE BY GOAL", blurb: "Find exactly what you need right now." };
    }
    if (isExplore && tradition) {
      const t = BROWSE_TRADITIONS.find((x) => x.id === tradition);
      let list = [];
      if (t) {
        list = catalog.filter((c) => {
          const badgeHit = (t.badges || []).some((b) => (c.badges || []).includes(b));
          const catHit = (t.cats || []).includes(c.category);
          const keyHit = (t.keys || []).some((k) => text(c).includes(k));
          return badgeHit || catHit || keyHit;
        });
      }
      return { items: list, title: t ? t.label : "By Tradition", eyebrow: "BROWSE BY TRADITION", blurb: "Explore the world's healing lineages \u2014 Musbat-u first." };
    }
    return { items: catalog, title: "Explore", eyebrow: "BROWSE", blurb: "" };
  }, [catalog, group, meta, isExplore, mood, goal, tradition]);

  const cardProps = { onWish: toggleWish, onBuy: buy, onPartner: partner, onOpen: openItem };
  const isHerbs = !!(meta && meta.cat === "herb");

  return (
    <>
      <Nav />
      <Seo title={title} description={blurb || "Browse Ely Wellbeing courses, therapies, retreats, herbs and digital resources."} />
      <section className="hero" style={{ padding: "9rem 0 2.5rem" }}>
        <div className="wrap">
          <span className="badge-gold">{eyebrow}</span>
          <h1 style={{ marginTop: "1rem", fontSize: "clamp(2rem,4vw,3.4rem)" }}>{title}</h1>
          <p className="lead">{blurb}</p>
        </div>
      </section>
      <section className="sec pad" style={{ paddingTop: "1rem" }}>
        <div className="wrap">
          {items.length ? (
            <div className="grid">
              {items.map((it) => <Card key={it.id} item={it} wished={wishedIds.includes(it.id)} {...cardProps} />)}
            </div>
          ) : (
            <div className="band" style={{ background: "var(--panel)" }}>
              <h2 style={{ color: "#fff" }}>Coming soon</h2>
              <p className="muted">We're curating content for this shelf. Explore <a className="text-btn" href="/musbat">Musbat-u</a> or <a className="text-btn" href="/learn">Learn</a> in the meantime.</p>
            </div>
          )}
          {isHerbs && (
            <p className="muted" data-testid="amazon-associates-disclosure" style={{ marginTop: "2rem", fontSize: "0.8rem", textAlign: "center", opacity: 0.75 }}>
              As an Amazon Associate, Ely earns from qualifying purchases. Product links may open Amazon UK or US.
            </p>
          )}
        </div>
      </section>
      <Footer />
    </>
  );
}
